<template>
    <div class="edit-profile gutter frame">
        <div v-if="form">
            <h2>Your Profile</h2>
            <edit-user :form="form" @updated="updateUser" :user="user"/>
        </div>
    </div>
</template>

<script>
    import BaseView        from '../../../App/Views/BaseView';
    import EditProfileForm from "../Forms/EditProfileForm";
    import EditUser        from "./EditUser";
    import { mapState }    from 'vuex';
    import User            from "../User";
    import UserStore       from "../Store/User";
    import Transition      from "../../../Lib/Objects/Transition";
    

    export default {
        components: { EditUser },
        extends   : BaseView,

        computed: {
            ...mapState('User', {
                user: user => {
                    return new User(user.id, user.name, user.email, user.avatar)
                }
            }),
        },

        watch: {
            user() {
                this.setForm();
            }
        },

        data() {
            return {
                form: null,
            }
        },

        methods: {
            updateUser() {
                new UserStore().set(this.form.user);
            },

            setForm() {
                this.form = new EditProfileForm(this.user);
            }
        },

        mounted() {
            this.setForm();
            new Transition('.edit-profile', 0.5).fadeInUp(32);
        },

        beforeDestroy() {
            new Transition('.edit-profile', 0.5).fadeOut();
        },
    }

</script>
